module.exports = __webpack_public_path__ + "assets/events_coup_plain.6155d8e4.svg";